/**
 * Generated by orval v8.17.0 🍺
 * Do not edit manually.
 * BESS Service Portal API
 * Bootstrap placeholder API for the BESS Service Portal stack.
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import axios from 'axios';
import type {
  AxiosError,
  AxiosRequestConfig,
  AxiosResponse
} from 'axios';

import type {
  AuthProblemDetails,
  AuthState,
  ForgotPasswordRequest,
  InviteAcceptRequest,
  LoginRequest,
  ResetPasswordRequest
} from '../../model';


type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;




/**
 * Local username + password login. On success a short-lived access token and a longer-lived refresh token are issued as HttpOnly cookies via `Set-Cookie` (no token is returned in the body — the browser cannot read them). Backed by the database user store since Increment 1a (DV-1232); repeated failures temporarily lock the account (Increment 1c, DV-1356).
 * @summary Authenticate with email and password
 */
export const login = (
    loginRequest: LoginRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<AuthState>> => {


    return axios.post(
      `/auth/login`,
      loginRequest,options
    );
  }



export const getLoginMutationOptions = <TError = AxiosError<AuthProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof login>>, TError,{data: LoginRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof login>>, TError,{data: LoginRequest}, TContext> => {

const mutationKey = ['login'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof login>>, {data: LoginRequest}> = (props) => {
          const {data} = props ?? {};

          return  login(data,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LoginMutationResult = NonNullable<Awaited<ReturnType<typeof login>>>
    export type LoginMutationBody = LoginRequest
    export type LoginMutationError = AxiosError<AuthProblemDetails>

    /**
 * @summary Authenticate with email and password
 */
export const useLogin = <TError = AxiosError<AuthProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof login>>, TError,{data: LoginRequest}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof login>>,
        TError,
        {data: LoginRequest},
        TContext
      > => {
      return useMutation(getLoginMutationOptions(options));
    }
    /**
 * Reads the refresh token cookie, validates it, and issues a new access token (rotating the refresh token). Returns the current principal. Used by the frontend to silently recover from an expired access token.
 * @summary Mint a new access token from the refresh cookie
 */
export const refresh = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<AuthState>> => {


    return axios.post(
      `/auth/refresh`,
      undefined,options
    );
  }



export const getRefreshMutationOptions = <TError = AxiosError<AuthProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof refresh>>, TError,void, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof refresh>>, TError,void, TContext> => {

const mutationKey = ['refresh'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof refresh>>, void> = () => {


          return  refresh(axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RefreshMutationResult = NonNullable<Awaited<ReturnType<typeof refresh>>>

    export type RefreshMutationError = AxiosError<AuthProblemDetails>

    /**
 * @summary Mint a new access token from the refresh cookie
 */
export const useRefresh = <TError = AxiosError<AuthProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof refresh>>, TError,void, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof refresh>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getRefreshMutationOptions(options));
    }
    /**
 * Hydrates auth state from the access token cookie (the cookie is HttpOnly, so the SPA cannot read it and must ask the backend). Returns `authenticated: false` with a null user when no valid token is present. The display name reflects the current account record, including profile edits made after the access token was issued.
 * @summary Return the current authenticated principal, or anonymous
 */
export const getCurrentUser = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<AuthState>> => {


    return axios.get(
      `/auth/me`,options
    );
  }




export const getGetCurrentUserQueryKey = () => {
    return [
    `/auth/me`
    ] as const;
    }


export const getGetCurrentUserQueryOptions = <TData = Awaited<ReturnType<typeof getCurrentUser>>, TError = AxiosError<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCurrentUser>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCurrentUserQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCurrentUser>>> = ({ signal }) => getCurrentUser({ signal, ...axiosOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCurrentUser>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCurrentUserQueryResult = NonNullable<Awaited<ReturnType<typeof getCurrentUser>>>
export type GetCurrentUserQueryError = AxiosError<unknown>


/**
 * @summary Return the current authenticated principal, or anonymous
 */

export function useGetCurrentUser<TData = Awaited<ReturnType<typeof getCurrentUser>>, TError = AxiosError<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCurrentUser>>, TError, TData>, axios?: AxiosRequestConfig}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCurrentUserQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}






/**
 * Clears the access and refresh token cookies. Because auth is stateless in Increment 0e there is no server-side session to revoke; an already issued access token remains valid until it expires. DB-backed refresh revocation lands in Increment 1 (DV-1232).
 * @summary Clear the authentication cookies
 */
export const logout = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {


    return axios.post(
      `/auth/logout`,
      undefined,options
    );
  }



export const getLogoutMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof logout>>, TError,void, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof logout>>, TError,void, TContext> => {

const mutationKey = ['logout'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof logout>>, void> = () => {


          return  logout(axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LogoutMutationResult = NonNullable<Awaited<ReturnType<typeof logout>>>

    export type LogoutMutationError = AxiosError<unknown>

    /**
 * @summary Clear the authentication cookies
 */
export const useLogout = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof logout>>, TError,void, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof logout>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getLogoutMutationOptions(options));
    }
    /**
 * Consumes a single-use invite token: sets the user's password (validated against the password policy), records the display name, activates the account (`PENDING_INVITE` → `ACTIVE`) and signs the user in — the response sets the same cookies as `POST /auth/login` (Increment 1d, DV-1233).
 * @summary Accept an invite and activate the account
 */
export const acceptInvite = (
    inviteAcceptRequest: InviteAcceptRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<AuthState>> => {


    return axios.post(
      `/auth/invite/accept`,
      inviteAcceptRequest,options
    );
  }



export const getAcceptInviteMutationOptions = <TError = AxiosError<AuthProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acceptInvite>>, TError,{data: InviteAcceptRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof acceptInvite>>, TError,{data: InviteAcceptRequest}, TContext> => {

const mutationKey = ['acceptInvite'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof acceptInvite>>, {data: InviteAcceptRequest}> = (props) => {
          const {data} = props ?? {};

          return  acceptInvite(data,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AcceptInviteMutationResult = NonNullable<Awaited<ReturnType<typeof acceptInvite>>>
    export type AcceptInviteMutationBody = InviteAcceptRequest
    export type AcceptInviteMutationError = AxiosError<AuthProblemDetails>

    /**
 * @summary Accept an invite and activate the account
 */
export const useAcceptInvite = <TError = AxiosError<AuthProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acceptInvite>>, TError,{data: InviteAcceptRequest}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof acceptInvite>>,
        TError,
        {data: InviteAcceptRequest},
        TContext
      > => {
      return useMutation(getAcceptInviteMutationOptions(options));
    }
    /**
 * Always returns `204` regardless of whether the email is known, so the endpoint cannot be used to enumerate accounts. When the email belongs to an ACTIVE user with a local credential, a single-use reset token (1-hour TTL by default, SHA-256-hashed at rest) is created and the reset link is emailed (Increment 1d, DV-1233).
 * @summary Request a password-reset email
 */
export const forgotPassword = (
    forgotPasswordRequest: ForgotPasswordRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {


    return axios.post(
      `/auth/password/forgot`,
      forgotPasswordRequest,options
    );
  }



export const getForgotPasswordMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof forgotPassword>>, TError,{data: ForgotPasswordRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof forgotPassword>>, TError,{data: ForgotPasswordRequest}, TContext> => {

const mutationKey = ['forgotPassword'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof forgotPassword>>, {data: ForgotPasswordRequest}> = (props) => {
          const {data} = props ?? {};

          return  forgotPassword(data,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ForgotPasswordMutationResult = NonNullable<Awaited<ReturnType<typeof forgotPassword>>>
    export type ForgotPasswordMutationBody = ForgotPasswordRequest
    export type ForgotPasswordMutationError = AxiosError<unknown>

    /**
 * @summary Request a password-reset email
 */
export const useForgotPassword = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof forgotPassword>>, TError,{data: ForgotPasswordRequest}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof forgotPassword>>,
        TError,
        {data: ForgotPasswordRequest},
        TContext
      > => {
      return useMutation(getForgotPasswordMutationOptions(options));
    }
    /**
 * Consumes a single-use password-reset token and sets a new password (validated against the password policy, including the no-reuse history). On success every browser session of the user is revoked (`revoked_reason=PASSWORD_RESET`) — the user signs in again with the new password (Increment 1d, DV-1233).
 * @summary Reset the password with an emailed token
 */
export const resetPassword = (
    resetPasswordRequest: ResetPasswordRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {


    return axios.post(
      `/auth/password/reset`,
      resetPasswordRequest,options
    );
  }



export const getResetPasswordMutationOptions = <TError = AxiosError<AuthProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetPassword>>, TError,{data: ResetPasswordRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof resetPassword>>, TError,{data: ResetPasswordRequest}, TContext> => {

const mutationKey = ['resetPassword'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resetPassword>>, {data: ResetPasswordRequest}> = (props) => {
          const {data} = props ?? {};

          return  resetPassword(data,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ResetPasswordMutationResult = NonNullable<Awaited<ReturnType<typeof resetPassword>>>
    export type ResetPasswordMutationBody = ResetPasswordRequest
    export type ResetPasswordMutationError = AxiosError<AuthProblemDetails>

    /**
 * @summary Reset the password with an emailed token
 */
export const useResetPassword = <TError = AxiosError<AuthProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetPassword>>, TError,{data: ResetPasswordRequest}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof resetPassword>>,
        TError,
        {data: ResetPasswordRequest},
        TContext
      > => {
      return useMutation(getResetPasswordMutationOptions(options));
    }
